import Head from "next/head";
import TitleProduct from "components/sections/TitleProduct";
import useScrollTop from "../../hooks/useScrollTop";
import { PromoBanner } from "components/Home/Promo";
import useWindowWidth from "hooks/useWindowWidth";
import Banner from "components/Blog/Banner";
import GrowYourApp from "components/Home/GrowYourApp";
import RevenueCalculator from "../../components/RevenueCalculator";

const bannerData = {
  title:
    "Wondering how changing the pricing structure or increasing the retention rate can impact your revenue?",
  description:
    "With Apphud’s revenue calculator, you can easily simulate different scenarios to validate your monetization strategies and identify the most profitable approach for your app",
  image: "/svgs/icons/pricing.svg",
};

export default function apprevenue() {
  const width = useWindowWidth();
  useScrollTop();

  return (
    <div className="wrapper">
      <Head>
        <title>Subscription app revenue calculator</title>
        <meta
          property="title"
          content="Subscription app revenue and LTV calculator - Apphud"
        />
        <meta
          name="description"
          content="Simulate different monetization scenarios to validate your strategies and identify the most profitable approach for your app with Apphud’s Subscription app revenue and LTV calculator."
        />
        <link
          rel="canonical"
          href="https://apphud.com/subscription-app-revenue-calculator"
        />
        <meta
          property="og:title"
          content="Subscription app revenue and LTV calculator - Apphud"
        />
        <meta
          name="keywords"
          content="app revenue calculator, LTV calculator, subscription app revenue"
        />
        <meta property="og:title" content="The best alternative to Adapty" />
        <meta
          property="og:description"
          content="Simulate different monetization scenarios to validate your strategies and identify the most profitable approach for your app with Apphud’s Subscription app revenue and LTV calculator."
        />
        <meta
          property="twitter:title"
          content="Subscription app revenue and LTV calculator - Apphud"
        />
        <meta
          property="twitter:description"
          content="Simulate different monetization scenarios to validate your strategies and identify the most profitable approach for your app with Apphud’s Subscription app revenue and LTV calculator."
        />
        <meta
          property="twitter:url"
          content="https://apphud.com/subscription-app-revenue-calculator"
        />
      </Head>
      <TitleProduct
        title={"Subscription App Revenue Calculator"}
        text={
          "Try out a handy tool for modeling the Revenue and LTV of your app's users to understand\n the payback point "
        }
        textStyles={width > 922 ? {} : { paddingTop: 7 }}
      />

      <div className="container">
        <Banner alt {...bannerData} />
      </div>

      <RevenueCalculator />

      <div style={{ marginTop: width > 922 ? 79 : 60 }}>
        <GrowYourApp title="See how subscription apps grow using Apphud" />
      </div>

      <div className="container">
        <PromoBanner />
      </div>
    </div>
  );
}
